import React, { FC, useEffect, useRef, useState } from 'react';
import { EventDtoV2 } from 'src/api/v2';
import QrCodePrintTemplate from './QrCodePrintTemplate';
import ReactToPrint from 'react-to-print';
import QRCodeCanvas from 'qrcode.react';
import { Button, FileUpload, Icon } from '@innovationnorway/cl-react';
import DialogActions from 'src/components/DialogActions/DialogActions';
import { useTranslation } from 'react-i18next';

type QrCodePrintModalProps = {
  event: EventDtoV2;
  inviteLink: string;
  onClose?: () => void;
};

const QrCodePrintModal: FC<QrCodePrintModalProps> = ({ event, inviteLink, onClose }) => {
  const componentRef = useRef(null);

  const [fileUrl, setFileUrl] = useState<string>();

  useEffect(() => {
    if (!fileUrl) return;

    return () => URL.revokeObjectURL(fileUrl);
  }, [fileUrl]);

  const { t: tCommon } = useTranslation();
  const { t: tEvents } = useTranslation('events');

  return (
    <div>
      <p className="text-align--center">{tEvents('qrCodeDescription')}</p>

      <div className="display--flex justify-content--center margin-bottom--2">
        <QRCodeCanvas value={inviteLink} size={300} />
      </div>

      <QrCodePrintTemplate event={event} inviteLink={inviteLink} logoSrc={fileUrl} ref={componentRef} />

      <div className="margin-top--2">
        <FileUpload
          multiple={false}
          label={tEvents('uploadLogo')}
          description={tCommon('dragFiles')}
          accept="image/svg+xml,image/png,image/jpeg,image/webp"
          onFilesSelected={([file]) => {
            setFileUrl(file ? URL.createObjectURL(file) : undefined);
            return undefined;
          }}
          deletionCallback={() => setFileUrl(undefined)}
        />
      </div>

      <DialogActions>
        <div>
          <ReactToPrint
            trigger={() => (
              <Button type="button">
                <Icon prefix="fasr" iconName="print" />
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
        </div>

        <div>
          <Button type="button" onClick={onClose}>
            {tCommon('cancel')}
          </Button>
        </div>
      </DialogActions>
    </div>
  );
};

export default QrCodePrintModal;
